export const newCreate_sv = {

"Creating_walk_top" : "Skapa promenad",
"FAQ_banner_top" : "Hur går det till och andra vanliga frågor",
"FAQ_question1" : "Hur går det till?",
"FAQ_question1_1" : "Välj den typ av promenad du vill skapa, oroa dig inte - du kan ändra i sista steget om något blir fel",
"FAQ_question1_2" : "Följ stegen och fyll i promenadens information",
"FAQ_question1_3" : "Skapa och lägg upp promenaden",
"FAQ_question1_4" : "Promenaden är nu tillgänglig tills den blir bokad i det nätverk du valt.",
"FAQ_question1_5" : "Om promenaden blir bokad så chattar du och bestämmer detaljerna",
"FAQ_question1_6" : "Träffas på promenad!",

"FAQ_question2" : "Vem kommer jag gå med?",
"FAQ_question2_answer" : "Promenaden kommer vara tillgänglig och fri att boka för alla i nätverket du lagt upp promenaden, såvida den ej är privat. Du som skapare har alltid kontroll att bestämma om promenaden blir av eller ej. Avboka promenaden om den inte passar, då blir promenaden ledig för andra att boka igen",

"FAQ_question3" : "Min promenad är bokad, hur ska jag tänka?",
"FAQ_question3_answer" : "Chatta med deltagaren och se om ni kommer överens om detaljerna. Möts och gå alltid på en offentlig plats. Om du inte kan delta av någon anledning kom ihåg att avboka promenaden och meddela ditt promenad sällskap",

"FAQ_question4" : "Min promenad blev inte bokad",
"FAQ_question4_answer" : "Känn dig inte nedslagen, ibland kan det bli så att promenaden ej bokas. Du kan testa att redigera promenaden och byta tid, eller dela den själv i andra sociala medier för att öka dina chanser. Du kan även lägga upp flera promenader vid olika tillfällen",

"FAQ_question5" : "Jag kan inte gå tiden jag satt",
"FAQ_question5_answer" : "Kom ihåg att meddela ditt promenad sällskap och avboka promenaden. Ni kan också prata i chatten och se om det går att boka om till en annan tid. Redigera då promenaden med den nya tiden",

"FAQ_question6" : "Jag vill chatta med personen innan jag bokar",
"FAQ_question6_answer" : "En chatt öppnas när promenaden bokas, då kan du chatta med personen. Om ni kommer fram till att inte promenera tillsammans så är det bara att boka av promenaden. Annars kan du skicka en vänförfrågan om den accepteras kan du också chatta med personen.",

"FAQ_question7" : "Vart ska vi mötas?",
"FAQ_question7_answer" : "Mötesplatsen placeras i kartan, där kan du även beskriva platsen närmare t.ex 'vid den röda dörren': Se till att ni alltid möts och går på en offentlig plats och va tillgänglig i chatten när promenaden närmar sig. Om ni har svårt att hitta varandra kan man lägga til lett audiorum i promenaden och prata där tills man hittat varandra på plats.",

"FAQ_question8" : "Jag vill promenera i grupp, hur gör jag?",
"FAQ_question8_answer" : "Det går utmärkt att gå i grupp, för att lägga upp en grupp-promenad som just kan bokas av upp till 8 personer behöver man vara Walking Talking Pro medlem",

"FAQ_question9" : "Hur bjuder jag in en specifik person till en promenad?",
"FAQ_question9_answers" : "För att bjuda in en specifikt person i appen behöver du vara walking talking pro medlem, då kan du skicka promenad förslag direkt från chatten eller personens profils",

"OpenNetwork_button" : "Öppna nätverket ",
"OpenNetwork_description" : "Promenader i det öppna nätverket är tillgängliga för alla i appen. Du styr själv vem du går med.",

"AudioWalk_Description" : "Går tillsammans på olika håll eller hitta varandra lättare på plats genom att mötas i ett privat audio-rum i appen. Inga telefonnummer måste bytas.",

"Network_Button" : "Nätverk",
"Network_Description" : "Välj i vilken utav dina privata eller offentliga nätverk du vill lägga upp en promenad",

"Group_button" : "Grupp",
"Group_description" : "Skapa en promenad som fler än en person kan boka och gå tillsammans i grupp",

"Invite_button" : "Inbjudan",
"Invite_description" : "Välj precis vem i ditt nätverk du vill skicka ett promenadförslag till",

"Private_button" : "Privat",
"Private_Description" : "En privat promenad syns endast för dig - Du måste aktivt dela promenaden i eller utanför appen för att den ska bli bokad",

"Profilebutton_button" : "Profil",
"Profilebutton_description" : "Lägg upp promenader som bara syns för andra som aktivt tittar i din profil-kalender",

"Repeat_description" : "Skapa flera av samma promenad, gör en promenad plan eller visa snabbt och enkelt din tillgänglighet med flera promenader på en gång",

"starting_of_walk" : "Promenaden startar",
"date_of_walk" : "Datum",
"StartingTime_of_walk" : "Starttid",
"length_of_walk" : "Promenadens längd",
"Walktime_preview" : "Förhandsgranska tiden",
"StartLength_walk" : "Start",
"EndLength_walk" : "Slut",
"ContinueNext_page" : "Välj och gå vidare",
"ContinueCancel_page" : "Avbryt",

"HowCarry_walk" : "Hur vill du genomföra din promenad?",
"Meet_In_person" : "Jag vill mötas på plats ",
"Meet_in_person_description" : "Du träffar personen vid bestämd plats och promenerar tillsammans",
"Remote_walk" : "Jag vill promenera på distans",
"BookedPerson_choice" : "Det är upp till bokaren hur vi ses",
"Choose_button" : "Välj ",

"Map_spot_pick" : "Välj mötesplats genom att placera en punkt i kartan eller använd sök funktionen nedanför",
"Search_field" : "Sök",
"Add_description_location" : "Lägg till en beskrivning av platsen",
"Describe_location" : "Beskriv platsen (valfritt) ",
"Select_locationContinue" : "Välj platsen och gå vidare",

"added_to_network" : "Läggs upp i nätverket",
"ButtonCreateTop" : "Skapa",
"Part4_OpenNetwork" : "Öppna nätverket",
"When_walk" : "När",
"Control_StartTime" : "Kontrollera din starttid",
"How_walk" : "Hur",
"AddWalk_description" : "Lägg till beskrivning",
"Pro_features" : "Pro-funktioner ",
"Walking_repeat" : "Repetera",
"Walking_DontRepeat" : "Repetera inte",
"Walk_invite" : "Bjud in",
"walk_choose_person" : "Välj person",
"Walk_available_spots" : "Tillgängliga platser",
"Walk_privateWalk" : "Privat promenad ",
"Walk_onlyIn_profile" : "Endast i min profil ",
"Walk_createWalk" : "SKAPA PROMENADEN ",
"Walk_cancelWalk" : "AVBRYT",

"Visible_network" : "Välj i vilket nätverk du vill att din promenad ska vara synlig och bokbar",
"Visible_network_Public" : "Offentliga nätverk",
"Visible_network_Open" : "Öppna nätverket",
"Visible_network_my" : "Mina nätverk",
"Visible_publicButton" : "Offentlig",

"Error_control_walk" : "Kontrollera din promenad",
"Your_walk_created" : "Din promenad har skapats, se din promenad:",
"Your_walk_created_multiple" : "Dina promenader har skapats",
"Go_to_walk_option" : "Gå till din promenad",
"Go_to_page_option" : "Gå till din sida",


"Upgrade_account" : "Uppgradera ditt konto",
"Upgrade_account_Info" : "För att får tillgång till denna funktion måste du uppgradera ditt konto till Pro",
"Upgrade_leave_page" : "Lämna och läs mer om pro",

"creatingwalkfp_choice" : "Välj en promenadtyp för att komma igång",
"cancel_errormessage_title" : "Avbryter",
"cancel_errormessage_header" : "Är du säker på att du vill avbryta?",
"cancel_errormessage_text" : "Avbryter du kommer du förlora din nuvarande data",

"tipsandinfo_top" : "Tips och info",
"tipsandinfo_infotext" : "Om du väljer att mötas på plats får du placera ut en kartpunkt där du vill mötas för din promenad. Väljer du att promenera på distans skapas ett samtalsrum i appen. Är det upp till bokaren måste ni bestämma i chatten hur ni ska ses.",
"tipsandinfo_tankpa" : "Tänk på:",
"tipsandinfo_iflocation" : "Om ni ses på plats: Promenera alltid i offentliga miljöer.",
"tipsandinfo_ifdistance" : "Om ni ses på distans: Inga telefon nummer behöver delas, ni pratar i appen.",
"tipsandinfo_decide" : "Du bestämmer alltid själv vem du vill gå eller prata med.",
"tipsandinfo_contact" : "Kontakta alltid bokaren i god tid om du av någon anledning måste ställa in.",

"availablespots" : "Välj antal tillgängliga platser för din promenad",

"remotewalk_info" : "Du och deltagare promenerar på olika håll i ett audio-rum i appen",
"upto_person_info" : "Ni bestämmer tillsammans vilket som passar bäst",

"part5_meetingspot" : "Mötespunkt:",

"topunder_search" : "Ingen",
"upperselectionfarright" : "vänlista",

"frequency_choice" : "Sätt frekvensen du vill upprepa din promenad",
"frequency_amount" : "Frekvens",
"frequency_choice1" : "Anpassad",
"frequency_choice2" : "Dagligen",
"frequency_choice3" : "Varje vecka på dagen",
"frequency_choice4" : "Varje månad på dagen",
"frequency_choice5" : "Varje vardag mån-fre",
"starttimeofwalk" : "Starttid",
"starttimeofwalk_howlong" : "Längd",
"set_frequency_repetition" : "Välj antal gånger promenaden ska repeteras",

"mappopup_description" : "Placera en punkt i kartan, starta genom att trycka på kartan eller sök efter platsen du vill mötas på i fältet ovanför",
"mapselectioncard_meet" : "Mötesplatsen",
"mapselectioncard_description" : "Beskriv platsen",
"mapselectioncard_detail" : "T.ex 'vid caféet', 'Den röda dörren' etc.",

"continuetonextpage" : "Välj och gå vidare",

"placeMapPin": 'Placera kartnålen där du vill mötas',
"setNumberOf": 'Välj antal',
"where_create": 'Var',

"error_title_length": 'Din titel måste vara längre än 3 bokstäver',
"error_set_meeting" : 'Du måste ange hur ni ska mötas',
'enter_description' : 'Beskriv promenaden',
"read_more_here" : "Läs mer här",
"walk_is_repeated" : "Promenaden repeteras",
}